import { mergeProps } from '@/utils/merge';
import { Navigation } from '../Navigation';

type BarMenuProps = { links: React.ComponentProps<typeof Navigation.Link>[] };

export const getNavigationBarMenu = ({ links }: BarMenuProps) => {
  return links.map((link, index) => {
    return (
      <Navigation.Link
        key={index}
        {...mergeProps(
          {
            options: {
              colors: 'bar',
              size: 'bar',
              variant: 'bar',
            },
          },
          link,
        )}
      />
    );
  });
};
